const NEGATIVE = 'negative';
const POSITIVE = 'positive';


export {
    NEGATIVE,
    POSITIVE
}
